import React from 'react';
import { PageHeader } from '../../packages/ui';
import { getMyWork } from '../../packages/api-client/work-api';
import { usePageTitle } from '../../hooks/usePageTitle';
import { WorkList } from './WorkList';

/** /my-work — open tasks assigned to the caller across every project (GET /me/work). */
export function MyWorkPage() {
    usePageTitle('My work');
    return (
        <div className="work-page">
            <PageHeader title="My work"
                subtitle="Open tasks assigned to you across projects. Overdue first, then by due date." />
            <WorkList queryKey="my-work" fetchPage={getMyWork} label="Tasks assigned to you"
                emptyTitle="Nothing assigned to you"
                emptyMessage="Open tasks assigned to you in any project will appear here." />
        </div>
    );
}
